<template>
  <v-dialog
    max-width="700"
    width="100%"
    :value="true"
    @click:outside="close"
    @keydown.esc="close"
    scrollable
  >
    <v-card :loading="loading">
      <v-system-bar window dark>
        Typ: {{ type.description }}
        <v-spacer />
        <v-btn @click="close" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>

      <v-card-text class="pt-4">
        <RowItem align="center" title="Titel">
          <h3>{{ type.title }}</h3>
        </RowItem>
        <RowItem align="center" title="erstellt von">
          <PersonItem :value="type.creator" />
        </RowItem>
        <RowItem title="Text">
          <Markdown :value="type.text" />
        </RowItem>
        <RowItem title="Abteilung">
          <LookupValue :value="type.division" />
        </RowItem>
        <RowItem title="Stufe">
          <LookupValue :value="type.grade" />
        </RowItem>
        <RowItem title="Semester">
          <LookupValue :value="type.semester" />
        </RowItem>
        <RowItem title="Fach">
          <LookupValue long :value="type.subject" />
        </RowItem>
        <RowItem title="automatisch">
          <v-simple-checkbox disabled :value="type.autogenerate" />
        </RowItem>
        <RowItem title="versteckt">
          <v-simple-checkbox disabled :value="type.hidden" />
        </RowItem>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn @click="edit" text color="primary" v-if="!type.archived">
          bearbeiten
        </v-btn>
        <v-spacer />
        <v-btn text @click="close">schliessen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import LookupValue from "common/components/LookupValue.vue";
import PersonItem from "common/components/PersonItem.vue";
import RowItem from "@/components/RowItem.vue";

export default defineComponent({
  name: "PortfolioDetail",
  props: ["id"],
  components: { LookupValue, PersonItem, RowItem },
  data() {
    return { type: {}, loading: false };
  },
  methods: {
    edit() {
      this.$router.push({
        name: "PortfolioTypeEdit",
        params: { id: this.type.id },
      });
    },
    close() {
      this.$router.push({
        name: "PortfolioTypeList",
      });
    },
  },
  async created() {
    this.loading = true;
    this.type = await this.apiGet({ resource: "portfolio/type", id: this.id });
    this.loading = false;
  },
});
</script>
